import { Button, Modal, Table } from 'antd';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import api from '../../../../service/api';
import { ApplicationState } from '../../../../store';
import { SKW_PREFIX } from '../../../../utils/constants';
import { maskCurrency, maskUnd } from '../../../../utils/mask';

interface Props {
  record: any;
}

interface DataType {
  codProduto: number;
  descricaoProduto: string;
  quantidade: number;
  volume: string;
  pesoBruto: number;
  valorTotal: number;
}

interface Pagination {
  total: number;
  pageSize: number;
  current: number;
}

const App: React.FC<Props> = ({ record }) => {
  const [open, setOpen] = useState<boolean>(false);
  const [nota, setNota] = useState<DataType[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [total, setTotal] = useState<number>(0);
  const token = useSelector((state: ApplicationState) => state.auth.token);

  const handleClick = (pagination: Pagination) => {
    setLoading(true);
    api
      .post(
        `call?serviceName=${SKW_PREFIX}getItensCte&pagina=${
          pagination ? pagination?.current - 1 : 0
        }&tamanhoPagina=${5}&token=${token}`,
        {
          nfNumNota: record?.nfNumNota,
          cteNunota: record?.cteNunota,
        }
      )
      .then((res) => {
        setNota(res.data?.itensCte);
        setTotal(res.data?.total);
        setOpen(true);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        Swal.fire({
          title: 'Ops...',
          text: 'Erro ao buscar os produtos da nota',
          icon: 'error',
          confirmButtonText: 'Ok',
        });
      });
  };

  const columns = [
    {
      key: 'codProduto',
      title: 'Código produto',
      dataIndex: 'codProduto',
      render: (text: any) => <>{text}</>,
    },
    {
      key: 'descricaoProduto',
      title: 'Produto',
      dataIndex: 'descricaoProduto',
      render: (text: any) => <>{text}</>,
    },
    {
      key: 'quantidade',
      title: 'Quantidade',
      dataIndex: 'quantidade',
      render: (text: any) => <>{maskUnd(text)}</>,
    },
    {
      key: 'volume',
      title: 'Unidade',
      dataIndex: 'volume',
      render: (text: any) => <>{text}</>,
    },
    {
      key: 'pesoBruto',
      title: 'Peso bruto',
      dataIndex: 'pesoBruto',
      render: (text: any) => <>{maskUnd(text) + ' KG'}</>,
    },
    {
      key: 'valorTotal',
      title: 'Valor total',
      dataIndex: 'valorTotal',
      render: (text: any) => <>{maskCurrency(text)}</>,
    },
  ];

  return (
    <>
      <Button
        type="link"
        onClick={() =>
          handleClick({
            total: 0,
            pageSize: 5,
            current: 1,
          })
        }
      >
        {record?.nfNumNota}
      </Button>

      <Modal
        title={`Lista de produtos - NF-${record.nfNumNota}`}
        centered
        visible={open}
        onOk={() => setOpen(false)}
        onCancel={() => setOpen(false)}
        width={1000}
        footer={null}
      >
        <Table
          columns={columns}
          dataSource={nota}
          loading={loading}
          pagination={{
            total: total,
          }}
          onChange={(pagination: any, filters: any, sorter: any) => {
            handleClick(pagination);
          }}
        />
      </Modal>
    </>
  );
};

export default App;
